import React from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Search as SearchIcon, Close as CloseIcon } from '@mui/icons-material';

const fontBase = { fontFamily: 'Roboto, Arial, sans-serif' };

/**
 * The search box every list page uses.
 *
 * Each page had grown its own copy with slightly different behaviour — two of
 * them only searched when you pressed Enter, none of them could be cleared
 * without selecting the text first. Debouncing is the caller's job (see
 * useDebouncedValue), because only the caller knows what it does with the term.
 */
const SearchField = ({
  value,
  onChange,
  placeholder = 'Search',
  sx = {},
  ...props
}) => (
  <TextField
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    size="small"
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon sx={{ color: '#9ca3af', fontSize: 20 }} />
        </InputAdornment>
      ),
      endAdornment: value ? (
        <InputAdornment position="end">
          <IconButton
            size="small"
            aria-label="Clear search"
            onClick={() => onChange('')}
            sx={{ color: '#9ca3af', '&:hover': { color: '#4b5563' } }}
          >
            <CloseIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </InputAdornment>
      ) : null,
    }}
    sx={{
      flex: 1,
      minWidth: '200px',
      maxWidth: '320px',
      ...fontBase,
      '& .MuiOutlinedInput-root': {
        backgroundColor: '#fff',
        borderRadius: '8px',
        fontSize: '14px',
        '& fieldset': { borderColor: '#e0e0e0' },
        '&:hover fieldset': { borderColor: '#9ca3af' },
        '&.Mui-focused fieldset': { borderColor: '#1976d2', borderWidth: '1px' },
      },
      ...sx,
    }}
    {...props}
  />
);

export default SearchField;
